var Policy = /** @class */ (function () {
    function Policy() {
        this.automaticAdjustmentKey = null;
        this.coverages = null;
        this.effectiveDate = null;
        this.expirationDate = null;
        this.policyNumber = null;
        this.premiumDiscountKey = null;
        this.premiumDiscountName = null;
        this.term = null;
        this.totalCost = 0;
        this.affinityGroupId = null;
        this.affinityGroupName = null;
        this.totalPremium = 0;
    }
    return Policy;
}());
export { Policy };
